import type { PublicIncidentSummary } from "@/v2-status-client/status/status.types"
import { formatIncidentDate } from "@/v2-status-client/status/status.utils"

export type IncidentGroup = {
  dateLabel: string
  // Sortable timestamp so React's stable order matches chronology.
  sortKey: number
  entries: PublicIncidentSummary[]
}

// Bucket incidents by their UTC start day so the timeline reads
// "Tuesday, Apr 27" with the per-scope rows underneath. Mirrors
// how StatusPage and most public status pages structure their
// incident history.
export function groupByDate(
  incidents: PublicIncidentSummary[],
): IncidentGroup[] {
  const map = new Map<string, IncidentGroup>()
  for (const i of incidents) {
    const ts = new Date(i.startedAt)
    const dayKey = Number.isNaN(ts.getTime())
      ? i.startedAt
      : `${ts.getUTCFullYear()}-${ts.getUTCMonth()}-${ts.getUTCDate()}`
    const existing = map.get(dayKey)
    if (existing) {
      existing.entries.push(i)
      continue
    }
    map.set(dayKey, {
      dateLabel: formatIncidentDate(i.startedAt),
      sortKey: Number.isNaN(ts.getTime()) ? 0 : ts.getTime(),
      entries: [i],
    })
  }
  return Array.from(map.values()).sort((a, b) => b.sortKey - a.sortKey)
}
